// Web フロントエンドのバージョン（単一ソース）。
// BE のリクエストログ（ComminExceptionHandlingFilter → keyValue("appVersion", ...)）に
// Web クライアントの版数を残すため、bootstrap.js が axios の既定ヘッダ X-APP-VERSION に
// この値を載せて送る。X-APP は送らないので BE のクライアント判定は Web のまま（client=Web と
// 一緒に appVersion=この値 が記録される）。リリースのたびにこの 1 行を上げる。
// （package.json の version は Vite テンプレ残骸の死値なので参照しない）
export const WEB_VERSION = '1.3.0'
